var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',[_c('kt-panel',[_c('kt-panel-body',[_c('ticket-form',{attrs:{"action":_vm.createTicket}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }